import { render, staticRenderFns } from "./TablePurchaseRequest.vue?vue&type=template&id=2d1c9c13&"
import script from "./TablePurchaseRequest.vue?vue&type=script&lang=ts&"
export * from "./TablePurchaseRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports